import { Size } from '../../models';

export function newSize(width: number, height: number): Size {
  return { width, height };
}
